import { ITelegramAccountRepository } from '../../ports/ITelegramAccountRepository';
import { TelegramAccountBrandingEntity } from '../../../domain/entities/TelegramAccountBranding';

export class GetTelegramAccountBrandingUseCase {
  constructor(private repo: ITelegramAccountRepository) {}
  async execute(uuid: string): Promise<TelegramAccountBrandingEntity> { return this.repo.getBranding(uuid); }
}
